<template>
  <div id="plateCorrectData">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>业务数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>车牌修正查询</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="loadPark"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="datetime"
                            :clearable="false"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="设备类型::">
            <el-select v-model="pageSearch.fDeviceID"
                       clearable
                       filterable
                       placeholder="请选择设备类型"
                       style="width:200px;">
              <el-option v-for="item in deviceNameList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.text">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可信度::">
            <el-input placeholder="请输入可信度"
                      v-model="pageSearch.fInConfidence"
                      class="search">
            </el-input>
          </el-form-item>
          <el-form-item label="车牌::">
            <el-input placeholder="请输入车牌"
                      v-model="pageSearch.fPalteNo"
                      class="search">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <!-- <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button> -->
          </el-form-item>
          <el-form-item style="float:right;margin-right:0px;">
            <el-button type="success"
                       size="small"
                       icon="el-icon-success"
                       @click="auto_update">自动修正</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  :cell-style="cellStyle"
                  border
                  stripe
                  ref="dt"
                  v-loading="loading"
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fInParkName1"
                           width="100"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fInChnlName1"
                           width="100"
                           label="通道名称">
          </el-table-column>
          <el-table-column prop="fInTimeName"
                           width="150"
                           label="进场时间">
          </el-table-column>
          <el-table-column prop="fInPlateUrl"
                           width="150"
                           label="车牌特写图片">
            <template slot-scope="scope">
              <img :src="scope.row.fInPlateUrl" />
            </template>
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌号码">
          </el-table-column>
          <el-table-column prop="fAliPlateCode"
                           width="100"
                           label="阿里车牌">
          </el-table-column>
          <el-table-column prop="fBaiduPlateCode"
                           width="100"
                           label="百度车牌">
          </el-table-column>
          <el-table-column prop="fRemark"
                           width="250"
                           label="备注">
          </el-table-column>
          <el-table-column prop="fPlateColor"
                           width="100"
                           label="车牌颜色">
          </el-table-column>
          <el-table-column prop="fInCapMode"
                           width="100"
                           label="进场方式">
          </el-table-column>
          <el-table-column prop="fInConfidence"
                           width="80"
                           label="可信度">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="350">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="modifyplate(scope.$index, scope.row)">修改</el-button>
              <el-button size="mini"
                         type="success"
                         @click="autoModifyPlate(scope.$index, scope.row)">自动匹配</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="handleInfo(scope.$index, scope.row)">明细</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="show_dev_in(scope.$index, scope.row)">图片</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="车牌修正"
                           width="80"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="autoModifyPlate(scope.$index, scope.row)">修正</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <carInfoView ref="child"
                 reportActiveName="pageData"
                 :type="1"></carInfoView>
    <el-dialog :title="dialog_dev_Title"
               width="55%"
               top="7vh"
               :visible.sync="dialogdevFormVisible"
               v-dialogDrag>
      <el-row>
        <el-col :span="12">
          <div class="car_imgs">
            <el-row>
              <div class="fplate_infos">
                <div style="float:left;width:200px;">
                  <el-image :src="form.fInPlatePic">
                    <div slot="error"
                         class="image-slots">
                      <i class="el-icon-picture-outlines"></i>
                    </div>
                  </el-image>
                </div>
                <div style="float:left;margin-left:20px;">
                  <div><span class="fplate_span">{{form.fPlateCode}}</span></div>
                  <div><span class="fplate_span">{{form.fPlateColor}}</span></div>
                  <div><span class="fplate_span">{{form.fConfidence}}</span></div>
                </div>
              </div>
            </el-row>
            <img :src="form.fInPic"
                 class="img" />
          </div>
        </el-col>
        <el-col :span="12">
          <el-form label-width="105px"
                   class="form_right">
            <fieldset>
              <legend>进场图片信息</legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场时间">
                    <el-input v-model="form.fInTime"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="操作用户">
                    <el-input v-model="form.fInUserName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场场库">
                    <el-input v-model="form.fInParkName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="进场通道">
                    <el-input v-model="form.fInChnlName"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="识别车牌">
                    <el-input v-model="form.fInPlate"
                              :class="{ isRed: form.fInPlate!=form.fPlateCode }"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="识别可信度">
                    <el-input v-model="form.fInConfidence"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场方式">
                    <el-input v-model="form.fInStatus"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="抓拍模式">
                    <el-input v-model="form.fInCapMode"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="进场备注"
                                class="fInRemark_item">
                    <el-input type="textarea"
                              :rows="2"
                              v-model="form.fInRemark"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset>
              <legend>进场设备信息</legend>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="摄像机IP">
                    <el-input v-model="form_dev.fInCamIP"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="摄像机类型">
                    <el-input v-model="form_dev.fInCamType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="道闸控制设备IP">
                    <el-input v-model="form_dev.fInGateIP"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="道闸类型">
                    <el-input v-model="form_dev.fInGateType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车辆方向">
                    <el-input v-model="form_dev.fInVehDir"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车身颜色">
                    <el-input v-model="form_dev.fInCarColor"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进场速度">
                    <el-input v-model="form_dev.fInSpeed"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="报警类型">
                    <el-input v-model="form_dev.fInAlarm"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车辆品牌">
                    <el-input v-model="form_dev.fInBrand"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="车辆类型">
                    <el-input v-model="form_dev.fInVehType"
                              :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogdevFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="modify_title"
               v-dialogDrag
               width="40%"
               id="modify_dialog"
               :visible.sync="dialogVisible">
      <el-form :model="plateModel"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="车牌号码::">
              <el-input v-model="plateModel.fPlateCode"
                        style="width:200px"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进场识别车牌::">
              <el-input v-model="plateModel.fInPlate"
                        style="width:200px"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="修改车牌为::"
                          prop="fModifiedPlate">
              <el-input v-model="plateModel.fModifiedPlate"
                        placeholder="请输入车牌"
                        style="width:200px"
                        ref="input_ModifiedPlate"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
                  class="tab_img">
            <div class="block">
              <!-- <span class="demonstration"
                    style="color:red">{{plateModel.fInExpiredTip}}</span> -->
              <!-- <el-image :src="plateModel.fInPlatePic">
                  <div slot="error"
                      class="image-slots">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image> -->
              <!-- <el-image :src="plateModel.fInPic">
                  <div slot="error"
                      class="image-slots-img">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image> -->
              <img :src="plateModel.fInPlatePic"
                   class="img" />
              <img :src="plateModel.fInPic"
                   class="imgr" />
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import carInfoView from '../../components/carInfoView'
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import { device as dev } from '../../api/device'
import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  components: { carInfoView },
  data () {
    return {
      plateModel: {
        fBigRowID: '',
        fModifiedPlate: ''
      },
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      dialog_dev_Title: '',
      dialogdevFormVisible: false,
      modify_title: '',
      dialogVisible: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      park_list: [],
      deviceNameList: [],
      pageCount: 0,
      startTime: '',
      endTime: '',
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fstartTime: '',
        fendTime: '',
        fDeviceID: '',
        fPalteNo: '',
        fInConfidence: '',
        isExport: 0
      },
      form: {
        fCustName: '',
        fParkName: '',
        fOpLastTime: '',
        fOpUserName: '',
        fConfidence: '',
        fPlateCode: '',
        fPlateColor: '',
        fCarTypeName: '',
        fInTime: '',
        fInChnlName: '',
        fInStatus: '',
        fOutTime: '',
        fOutChnlName: '',
        fOutStatus: '',
        fTotalSecs: '',
        fFreeSecs: '',
        fPaySecs: '',
        fRateGroupName: '',
        fCalcAmt: '',
        fPayAmt: '',
        fExgDate: '',
        fInPlate: '',
        fInRemark: '',
        fInPic: '',
        fInPlatePic: '',
        fInExpiredTip: ''
      },
      form_dev: {
        fInCamIP: '',
        fInCamType: '',
        fInGateIP: '',
        fInGateType: '',
        fInVehDir: '',
        fInCarColor: '',
        fInSpeed: '',
        fInVehType: '',
        fInAlarm: '',
        fOutCamIP: '',
        fOutCamType: '',
        fOutGateIP: '',
        fOutGateType: '',
        fOutVehDir: '',
        fOutCarColor: '',
        fOutSpeed: '',
        fOutVehType: '',
        fOutAlarm: ''
      },
      rules: {
        fModifiedPlate: [
          { required: true, message: '请输入车牌', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.isExport = 0
      this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      api.getPlateCorrectList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
            this.total = data.Data.total
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            this.$message.error('提示：车牌修正数据加载失败')
          }
        }
      })
    },
    cellStyle (row, column, rowIndex, columnIndex) {
      // 根据报警级别显示颜色
      // console.log(row.row.fRemark)
      if (row.row.fAliPlateCode !== '' && row.row.fBaiduPlateCode !== '') {
        if (row.row.fPlateCode !== row.row.fAliPlateCode || row.row.fPlateCode !== row.row.fBaiduPlateCode) {
          return 'color:red'
        }
      } else {
        if (row.row.fAliPlateCode !== '') {
          if (row.row.fPlateCode !== row.row.fAliPlateCode) {
            return 'color:red'
          }
        } else if (row.row.fBaiduPlateCode !== '') {
          if (row.row.fPlateCode !== row.row.fBaiduPlateCode) {
            return 'color:red'
          }
        } else {
          // if (row.row.fRemark !== '') {
          //   return 'color:red'
          // }
        }
      }
    },
    auto_update () {
      this.$confirm('车牌自动全部修正, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.pageSearch.isExport = 0
        this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
        this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
        api.allAutoModifyPlate(this.pageSearch).then(res => {
          this.loading = false
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.pageData = data.Data.data || []
              this.pageCount = data.Data.count
              this.total = data.Data.total
              setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
              // this.page_list()
            } else {
              this.$message.error('提示：车牌自动修正数据失败')
            }
          }
        })
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fInParkID = ''
      this.park_list = []
      // this.deviceNameList = []

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    // changePark () {
    //   // 数据列表
    //   this.page_list()
    // },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadPark(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      // 相机设备类型
      dev.getDeviceNameList().then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.deviceNameList = data.Data.CameraTypeList || []
            } else {
              this.$message.error('提示：加载相机设备列表失败')
            }
          }
        }
      })
    },
    submitForm (formName) {
      if (this.plateModel.fModifiedPlate && (this.plateModel.fModifiedPlate || '').trim().length > 0) {
        var fMp = this.plateModel.fModifiedPlate
        var mp = /^((?!i|o|I|O).)*$/
        if (!mp.test(fMp)) {
          this.$message.error('修改后的车牌，不能包含i和o')
          return false
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.reportModifyPlateCode({ fPlateCode: this.plateModel.fModifiedPlate, fBigRowID: this.plateModel.fBigRowID }).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.page_list()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      api.carDepartureExport(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    autoModifyPlate (index, row) {
      api.autoModifyPlate({ fBigRowID: row.fBigRowID, fInPicUrl: row.fInPicUrl, fPlateCode: row.fPlateCode }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.$message({ type: 'success', message: data.Msg })
            this.page_list()
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    modifyplate (index, row) {
      api.carBusInfo({ type: 1, id: row.fBigRowID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var rowData = data.Data || {}
            if ((rowData.fInPic || '').length <= 0) {
              rowData.fInPic = ' '
            }
            if ((rowData.fOutPic || '').length <= 0) {
              rowData.fOutPic = ' '
            }
            rowData.fModifiedPlate = rowData.fPlateCode
            Object.assign(this.plateModel, rowData)
            this.modify_title = '【' + rowData.fCustName + '-' + rowData.fInParkName + '】修改车牌'
            this.dialogVisible = true
            this.$nextTick(() => {
              this.$refs.input_ModifiedPlate.focus()
            })
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    show_dev_in (index, row) {
      var param = {}
      if (row.fBigRowID) {
        if (row.fType) {
          param = { id: row.fBigRowID, type: row.fType, isSync: (this.reportActiveName === 'synPageData') }
        } else {
          param = { id: row.fBigRowID, type: 1, isSync: (this.reportActiveName === 'synPageData') }
        }
      } else {
        param = { id: 0, fCustID: row.fCustID, fBusID: row.fBusID, type: this.type, isSync: (this.reportActiveName === 'synPageData') }
      }
      api.carBusInfo(param).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var rowData = data.Data || {}
            if ((rowData.fInPic || '').length <= 0) {
              rowData.fInPic = ' '
            }
            if ((rowData.fOutPic || '').length <= 0) {
              rowData.fOutPic = ' '
            }
            rowData.fInParkChnlName = rowData.fInChnlName
            if ((rowData.fInParkName || '').trim().length > 0) {
              rowData.fInParkChnlName += '(' + rowData.fInParkName + ')'
            }
            rowData.fOutParkChnlName = rowData.fOutChnlName
            if ((rowData.fOutParkName || '').trim().length > 0) {
              rowData.fOutParkChnlName += '(' + rowData.fOutParkName + ')'
            }
            this.form = rowData
            this.dialog_dev_Title = '【'
            if ((this.form.fCustName || '').length > 0) {
              this.dialog_dev_Title += this.form.fCustName
            }
            if ((this.form.fInParkName || '').length > 0) {
              if (this.dialog_dev_Title !== '【') {
                this.dialog_dev_Title += '-' + this.form.fInParkName
              } else {
                this.dialog_dev_Title += this.form.fInParkName
              }
            }
            if ((this.form.fInChnlName || '').length > 0) {
              if (this.dialog_dev_Title !== '【') {
                this.dialog_dev_Title += '-' + this.form.fInChnlName
              } else {
                this.dialog_dev_Title += this.form.fInChnlName
              }
            }
            if (this.dialog_dev_Title !== '【') {
              this.dialog_dev_Title += '】' + this.form.fPlateCode
            } else {
              this.dialog_dev_Title = this.form.fPlateCode
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
      this.dialogdevFormVisible = true
      this.form_dev = {}
      api.carDevInfo({ fCustID: row.fCustID, fBusID: row.fBusID, type: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.form_dev = data.Data || {}
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 246
      obj.tableHeight = clientHeight
      this.setImgHeight()
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 61000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
#plateCorrectData .tab_img .block {
  text-align: center;
  position: relative;
  margin-top: 20px;
}
#plateCorrectData .tab_img .demonstration {
  display: block;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 5px;
}
#plateCorrectData .tab_img .el-image {
  width: 150px;
  height: auto;
  display: inline-block;
  margin-left: 10px;
}
#plateCorrectData .tab_img .img {
  width: 30%;
  /* height: 358px; */
  height: auto;
  text-align: center;
}
#plateCorrectData .tab_img .imgr {
  float: right;
  width: 70%;
  height: 358px;
  /* height: auto; */
  text-align: center;
}
#plateCorrectData .tab_img .image-slots {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
#plateCorrectData .fInRemark_item .el-form-item__content {
  height: auto;
}
#plateCorrectData .fplate_infos {
  overflow: hidden;
  width: 350px;
  margin: 5px auto;
}
#plateCorrectData .car_imgs .img {
  width: 100%;
  height: 358px;
}
#plateCorrectData .car_imgs .image-slots {
  width: 200px;
  height: 80px;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
  display: inline-block;
  line-height: 80px;
  text-align: center;
}
/* dialog弹出框样式 */
#plateCorrectData .el-dialog {
  min-width: 840px;
}
#plateCorrectData .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#plateCorrectData .el-dialog__title {
  color: white;
}
#plateCorrectData .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#plateCorrectData .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
/* 文本框样式 */
#plateCorrectData .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#plateCorrectData .el-input.is-disabled .el-input__inner,
#plateCorrectData .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#plateCorrectData .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
#plateCorrectData .el-input__icon {
  line-height: 32px;
}
/* end */
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/report/plateCorrectData.vue